import React from "react"
import { ChevronRight } from "lucide-react"
import { cn } from "../../lib/utils"
import { useSidebar } from "./sidebar"

const MobileSidebarTrigger = React.forwardRef(({ className, ...props }, ref) => {
  const { toggleSidebar, state, isMobile, openMobile } = useSidebar()
  const isCollapsed = state === "collapsed"

  return (
    <button
      ref={ref}
      onClick={toggleSidebar}
      className={cn(
        "fixed top-0 flex h-6 w-6 items-center justify-center rounded-r-md bg-white shadow-md border border-l-0 border-gray-200 transition-all duration-300 ease-in-out hover:shadow-lg hover:w-7 hover:bg-gray-50",
        "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50",
        "md:hidden", // Hide on desktop, show only on mobile
        // Higher z-index when mobile sheet is open to appear above it
        isMobile && openMobile ? "z-[60]" : "z-50",
        // Position based on sidebar state and device type
        isMobile 
          ? openMobile 
            ? "left-[240px]" // Position inside the opened mobile sheet
            : "left-0" // Fixed position when mobile sheet is closed
          : isCollapsed ? "left-[80px]" : "left-[240px]", // Desktop positioning
        // Smooth transition for position changes
        "transform transition-all duration-300 ease-in-out",
        className
      )}
      title={isMobile ? (openMobile ? "Close Sidebar" : "Open Sidebar") : (isCollapsed ? "Expand Sidebar" : "Collapse Sidebar")}
      aria-label={isMobile ? (openMobile ? "Close Sidebar" : "Open Sidebar") : (isCollapsed ? "Expand Sidebar" : "Collapse Sidebar")}
      {...props}
    >
      <ChevronRight 
        className={cn(
          "h-4 w-4 text-gray-700 transition-all duration-300 ease-in-out",
          isMobile 
            ? openMobile ? "rotate-180" : "rotate-0"
            : isCollapsed ? "rotate-0" : "rotate-180",
          "hover:text-gray-900"
        )}
      />
    </button>
  )
})

MobileSidebarTrigger.displayName = "MobileSidebarTrigger"

export { MobileSidebarTrigger }